import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ProfileState } from './profile.state';
import { Subscription } from '@core/models/entities/subscription.model';

const selectProfileFeature = createFeatureSelector<ProfileState>('profile');

export const selectUser = createSelector(selectProfileFeature, (state: ProfileState) => ({
  user: state.user || null,
}));

export const selectUserCompany = createSelector(selectProfileFeature, (state: ProfileState) => ({
  company: 'company' in state.user! ? state.user.company : null,
}));

export const selectUserView = createSelector(selectProfileFeature, (state: ProfileState) => state.user);

export const selectSubscription = createSelector(selectProfileFeature, (state: ProfileState) => state.subscriptions);

export const selectSubscriptionLength = createSelector(
  selectProfileFeature,
  (state: ProfileState) => state.subscriptions?.length ?? 0
);

export const selectError = createSelector(selectProfileFeature, (state: ProfileState) => ({
  error: state.error || null,
}));

export const mockSubscriptions: Subscription[] = [];
